import { FinalCta } from '../components/FinalCta'
import { PageHero } from '../components/PageHero'
import { Seo } from '../components/Seo'
import { faqs } from '../data/faqs'

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: { '@type': 'Answer', text: faq.answer },
  })),
}

export function FaqPage() {
  return (
    <>
      <Seo title="Frequently Asked Questions" description="Answers about mobile notary appointments, identification, travel fees, e-notary eligibility, certified copies, apostille assistance, and legal boundaries." path="/faq" schema={faqSchema} />
      <PageHero eyebrow="Frequently asked questions" title="Prepare with confidence." intro="The best appointment starts with clear expectations. These answers cover common practical questions about mobile notary and document support services." compact />
      <section className="section"><div className="container faq-page-grid"><div className="faq-list large-faq-list">{faqs.map((faq) => <details key={faq.question}><summary>{faq.question}</summary><p>{faq.answer}</p></details>)}</div><aside className="notice-card sticky-card"><strong>Still have a practical question?</strong><p>Use the contact form for scheduling or service questions. Legal questions should be directed to a licensed attorney.</p></aside></div></section>
      <FinalCta />
    </>
  )
}
